/**
 * R7E_AuthData
 * 
 * Data class for storing authentication information including username, token,
 * user ID, roles, and pending registrations.
 */
class R7E_AuthData {
    username = '';
    name = '';
    email = '';
    token = '';
    userid = null;
    refreshKey = '';
    roles = [];
    pendingRegistrations = {};
    constructor() {
        this.username = '';
        this.name = '';
        this.email = '';
        this.token = '';
        this.userid = null;
        this.refreshKey = '';
        this.roles = [];
        this.pendingRegistrations = {};
    }

    getKeys() {
        return ['username', 'name', 'email', 'token', 'userid', 'refreshKey', 'roles', 'pendingRegistrations'];
    }
    getKeyValues() {
        return {
            username: this.username,
            name: this.name,
            email: this.email,
            token: this.token,
            userid: this.userid,
            refreshKey: this.refreshKey,
            roles: this.roles,
            pendingRegistrations: this.pendingRegistrations
        };
    }
    setName(name) {
        this.name = name;
    }
    setEmail(email) {
        this.email = email;
    }

    clear() {
        this.username = '';
        this.name = '';
        this.email = '';
        this.token = '';
        this.userid = null;
        this.refreshKey = '';
        this.roles = [];
        this.pendingRegistrations = {};
    }
}

export { R7E_AuthData };

